module.exports = __webpack_public_path__ + "4dc2fa7d453c9180254a59a4124a36c9.pdf";